<ng-container [ngSwitch]="entryGroup?.displayType">
  <ng-container *ngSwitchCase="PRODUCT_BUNDLE_TYPE">
    <ng-container *ngFor="let orderEntry of entryGroup.entries">
      <div class="bundle-orderEntry"
          data-cy="bundle-orderEntry">
        <ng-container
          *ngTemplateOutlet="providedOrderEntriesTmpl, context: {
          $implicit: {
            collapsable: (entryGroup.entries.length > 1 || editionsInContractGroup > 1),
            collapsed: true,
            entry: orderEntry,
            isInvalid: hasInvalidEntry,
            derivativeCount: this.derivativeCount
            }
          }"
        ></ng-container>
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="DATE_BUNDLE_TYPE">
    <ng-container *ngTemplateOutlet="entryGroupSplit"></ng-container>
  </ng-container>
</ng-container>
<ng-container
  *ngFor="
    let subEntryGroup of entryGroup.entryGroups;
    let parentGroupIndex = index
  "
>
  <udex-tile
    *ngIf="this.containsRootGroups(subEntryGroup)"
    tabindex="0"
    libGroupSkip
    [groupSkipContent]="true"
    [interactive]="true"
    [href]="'javascript:void(0)'"
  >
    <dcp-entry-group
      class="udex-mb-32"
      [class.bundle-order-review-table]="this.containsRootGroups(subEntryGroup)"
      [entryGroup]="subEntryGroup"
      [editionsInContractGroup]="this.editionsInContractGroup"
      [providerContractCount]="providerContractCount"
      [parentEntryGroup]="entryGroup"
      [parentGroupIndex]="parentGroupIndex"
      [derivativesTmpl]="derivativesTmpl"
      [groupTotalTmpl]="groupTotalTmpl"
      [recurringTotalTmpl]="recurringTotalTmpl"
      [paymentTmpl]="paymentTmpl"
      [providedOrderEntriesTmpl]="providedOrderEntriesTmpl"
      [termsAndConditionsTmpl]="termsAndConditionsTmpl"
    >
    </dcp-entry-group>
  </udex-tile>
  <dcp-entry-group
    *ngIf="!this.containsRootGroups(subEntryGroup)"
    [class.bundle-order-review-table]="this.containsRootGroups(subEntryGroup)"
    [class.entry-group--invalid]="containsInvalidEntry(subEntryGroup)"
    [class.mb-5]="this.containsRootGroups(subEntryGroup)"
    [entryGroup]="subEntryGroup"
    [editionsInContractGroup]="this.editionsInContractGroup"
    [providerContractCount]="providerContractCount"
    [parentEntryGroup]="entryGroup"
    [parentGroupIndex]="parentGroupIndex"
    [derivativesTmpl]="derivativesTmpl"
    [groupTotalTmpl]="groupTotalTmpl"
    [recurringTotalTmpl]="recurringTotalTmpl"
    [paymentTmpl]="paymentTmpl"
    [providedOrderEntriesTmpl]="providedOrderEntriesTmpl"
    [termsAndConditionsTmpl]="termsAndConditionsTmpl">
  </dcp-entry-group>
</ng-container>
<ng-template #entryGroupSplit>
  <ng-container *ngIf="!containsInvalidEntry(entryGroup)">
    <ng-container *ngIf="paymentTmpl">
      <div class="bundle-payments" data-cy="bundle-payment">
        <ng-container
          *ngTemplateOutlet="paymentTmpl, context: {
            $implicit: {
              entry: entryGroupService.getFirstEntry(entryGroup.entryGroups),
              entryCount: providerContractCount
            }
          }"
        ></ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="derivativesTmpl">
      <div class="bundle-derivatives" data-cy="bundle-derivatives">
        <ng-container
          *ngTemplateOutlet="derivativesTmpl, context: {
              $implicit: {
                derivativeCount: derivativeCount,
                providerContract: entryGroup
              }
            }"
        ></ng-container>
      </div>
      <div class="bundle-recurring-total">
        <ng-container
          *ngTemplateOutlet="recurringTotalTmpl, context: {
            $implicit: {
              providerContract: entryGroup
            }
          }"
        ></ng-container>
      </div>
      <div class="bundle-group-total" data-cy="bundle-group-total">
        <ng-container
          *ngTemplateOutlet="groupTotalTmpl, context: {
            $implicit: {
              providerContract: entryGroup
            }
          }"
        ></ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="termsConditionsEntries as entries">
      <ng-container *ngIf="entries.length">
        <div *ngIf="termsAndConditionsTmpl" class="bundle-terms-and-conditions body--s udex-ps-20 udex-mb-12 udex-mt-8"
             data-cy="bundle-terms-and-conditions">
          <ng-container
            *ngTemplateOutlet="termsAndConditionsTmpl, context: {
              $implicit: {
                removalStatus: termsConditionsEntries[0]?.removed,
                entry: termsConditionsEntries[0],
                entries: termsConditionsEntries
              }
            }"
          ></ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>
